<ng-container *ngIf="isLoaded()">
  <!-- 1. ACCIONES -->
  <dossierActionsList [dossierId]="dossierId" [showRunnigRules]="showRunnigRules&&visibleRunningRules">
  </dossierActionsList>
  <!-- 2. AUDITORIA (TAREAS DE OTROS USUARIOS) -->
  <ng-container *ngIf="isShowAudit()">
    <ng-container *ngIf="auditList && auditList.length > 0">
      <div class="col-12 m-t-md">
        <span class=" lead"> {{ 'DossierActions.otherUsers' | translate }} </span>
        <p-table [value]="auditList" sortField="dateArrival" sortOrder="1" class="footer-over-pagination">
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="3">
                {{ 'General.noData' | translate }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="">{{ 'DossierActions.task' | translate }}</th>
              <th class="USERTH">{{ 'DossierActions.mailbox' | translate }}</th>
              <th class="DATETH">{{'General.date.text'| translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-task>
            <tr>
              <td>{{ task.description }}</td>
              <td class="USERTH">
                <ng-container *ngIf="task.inbox">
                  <button *ngIf="task.inbox.name" class="btn btn-sm btn-outline-primary w-100" aria-expanded="false"
                    title="{{ 'General.visualize' | translate}}" (click)="showInbox(task)">
                    <i class="fas fa-inbox" aria-hidden="true"> </i>
                    <span class="d-none d-sm-inline"> {{ task.inbox.name?task.inbox.name:task.inbox.identifier }}</span>
                  </button>
                </ng-container>
                <user *ngIf="task.user && task.user.identifier" [user]="task.user"></user>
              </td>
              <td class="DATE">
                <span>
                  <i class="fa fa-calendar-check-o"></i> {{ task.dateArrival | date: 'dd/MM/yyyy HH:mm' }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-container>
  </ng-container>
  <!-- </div> -->
</ng-container>